var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.103 30V29.2501V1.7986L139.668 40L101.103 78.2014V50.7513V50V30ZM99.6034 30.7539V49.2541C89.7222 49.3802 80.0821 52.3355 71.8499 57.7721C63.4091 63.3465 56.8282 71.2788 52.9426 80.5641C49.057 89.8496 48.0421 100.069 50.0268 109.927C51.9618 119.538 56.6629 128.382 63.5541 135.397L50.385 148.442C40.8932 138.837 34.4245 126.701 31.7755 113.51C29.0779 100.078 30.4621 86.1543 35.7534 73.5008C41.0447 60.8472 50.0059 50.031 61.5046 42.421C72.7954 34.9484 86.0346 30.8971 99.6034 30.7539ZM99.6034 170V170.75V198.201L61.0384 160L99.6034 121.799V149.249V150V170ZM101.103 150.746C110.985 150.62 120.625 147.664 128.857 142.228C137.298 136.653 143.879 128.721 147.764 119.436C151.65 110.15 152.665 99.9308 150.68 90.0729C148.745 80.4619 144.044 71.6176 137.153 64.6033L150.322 51.5584C159.814 61.1627 166.282 73.2993 168.931 86.49C171.629 99.9224 170.245 113.846 164.953 126.499C159.662 139.153 150.701 149.969 139.202 157.579C127.911 165.052 114.672 169.103 101.103 169.246V150.746Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/UpdateIcon.bdfffadfbbfa783e81a0acf6c9a63e22.svg";
export { ForwardRef as ReactComponent };